module.exports = __webpack_public_path__ + "static/media/icon_logo.d62ec5de.svg";